import { KeyValuePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AffiliatesTierCardComponent } from '@features/affiliates/affiliates-tier-card/affiliates-tier-card.component';
import { AffiliatesService } from '@features/affiliates/services/affiliates.service';

@Component({
  selector: 'app-affiliates-tiers-modal',
  imports: [AffiliatesTierCardComponent, KeyValuePipe],
  templateUrl: './affiliates-tiers-modal.component.html',
  styleUrl: './affiliates-tiers-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'modal-container flex flex-col',
  },
})
export class AffiliatesTiersModalComponent {
  public readonly affiliatesService = inject(AffiliatesService);
}
